var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortDesc = function SvgSortDesc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1953 2.19526C4.45565 1.93491 4.87776 1.93491 5.13811 2.19526L7.80478 4.86193C8.06513 5.12228 8.06513 5.54439 7.80478 5.80474C7.54443 6.06509 7.12232 6.06509 6.86197 5.80474L5.33337 4.27614V10.6667C5.33337 11.0349 5.0349 11.3333 4.66671 11.3333C4.29852 11.3333 4.00004 11.0349 4.00004 10.6667V4.27614L2.47145 5.80474C2.2111 6.06509 1.78899 6.06509 1.52864 5.80474C1.26829 5.54439 1.26829 5.12228 1.52864 4.86193L4.1953 2.19526Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 11.7239V5.33333C10.6667 4.96514 10.9652 4.66667 11.3334 4.66667C11.7016 4.66667 12 4.96514 12 5.33333V11.7239L13.5286 10.1953C13.789 9.93491 14.2111 9.93491 14.4714 10.1953C14.7318 10.4556 14.7318 10.8777 14.4714 11.1381L11.8048 13.8047C11.5444 14.0651 11.1223 14.0651 10.862 13.8047L8.1953 11.1381C7.93495 10.8777 7.93495 10.4556 8.1953 10.1953C8.45565 9.93491 8.87776 9.93491 9.13811 10.1953L10.6667 11.7239Z",
    fill: "#24396A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortDesc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "SortDesc.96bdcaa58a01c73f8eaae2e564350395.svg";